import { AbstractPmsApiService } from "./abstract.service";
import {Policy} from "../models";
/**
 * @class PolicyPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Property>}
 */
export class PolicyPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/policy';
    }
   
    get (property) {
        
        const url = this.url({propertyId: property.id});
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    save (property, policy) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
            .post(url, policy, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    newModel(params){
        return new Policy(params);
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/policy.service.js